import { GeoJsonLayer } from '@deck.gl/layers';
import { featureCollection, point } from '@turf/helpers';

export type RgbaColor = [number, number, number, number];

export interface RoutePingDot {
  borderColor: RgbaColor;
  fillColor: RgbaColor;
  lat: number;
  lineWidth: number;
  lng: number;
  radius: number;
}

export interface RoutePingFeature {
  properties: {
    borderColor: RgbaColor;
    color: RgbaColor;
    lineWidth: number;
    radius: number;
  };
}

/**
 * The one definition of a GPS route drawn as dots. Callers decide each dot's
 * color, radius and border — Live Map keys them off ping state, Truck Replay off
 * the truck and its highlight — while the feature shape and the pixel-unit
 * accessors that make dot size zoom-independent live here.
 */
export function buildRoutePingLayer(id: string, dots: RoutePingDot[]) {
  if (dots.length === 0) return null;

  const data = featureCollection(
    dots.map((dot) =>
      point([dot.lng, dot.lat], {
        borderColor: dot.borderColor,
        color: dot.fillColor,
        lineWidth: dot.lineWidth,
        radius: dot.radius,
      }),
    ),
  );

  return new GeoJsonLayer({
    data,
    getFillColor: (feature: RoutePingFeature) => feature.properties.color,
    getLineColor: (feature: RoutePingFeature) => feature.properties.borderColor,
    getLineWidth: (feature: RoutePingFeature) => feature.properties.lineWidth,
    getPointRadius: (feature: RoutePingFeature) => feature.properties.radius,
    id,
    lineWidthUnits: 'pixels',
    pointRadiusUnits: 'pixels',
    stroked: true,
  });
}
